<template>

    <div>
        <div class="w-100 " v-if="isBooking">
            <!--is booking-->
            <div class="d-flex justify-content-between  mb-10px ">
                <div class="" >
                    <h4 class="font-bold">
                        <span>{{flightObj.flightGroup[0].flight[0].flight.DepAirport}}-</span>
                        <span>{{flightObj.flightGroup[0].flight[flightObj.flightGroup[0].flight.length-1].flight.ArrAirport}}</span>
                    </h4>

                    <!-- <div>
                        <strong>{{flightObj.flightGroup[0].flightStatus}}</strong>
                    </div> -->
                    <div class="d-flex exchange-date-picker  d-flex align-center min-h-40px align-item-center">
                        <label v-if="flightObj.flightGroup[0].id.includes('_OB')"
                               class="d-flex white-space-pre align-item-center mb-0">
                            Depart
                        </label>
                        <strong v-if="flightObj.flightGroup[0].id.includes('_OB') && flightObj.flightGroup[0].exchangedDate"
                                class="d-flex white-space-pre align-item-center mb-0">
                            {{flightObj.flightGroup[0].exchangedDate|formatDate}}
                        </strong>
                        <strong v-else-if="flightObj.flightGroup[0].exchangedDate==null && flightObj.flightGroup[0].id.includes('_OB')"
                                class="d-flex white-space-pre align-item-center mb-0">
                            {{flightObj.flightGroup[0].flight[0].flight.DepDate|formatDate}}
                        </strong>
                        <label v-if="flightObj.flightGroup[0].id.includes('_IB')"
                               class="d-flex white-space-pre align-item-center mb-0">
                            Return
                        </label>
                        <strong v-if="flightObj.flightGroup[0].id.includes('_IB') && flightObj.flightGroup[0].exchangedDate"
                                class="d-flex white-space-pre align-item-center mb-0">
                            {{flightObj.flightGroup[0].exchangedDate|formatDate}}
                        </strong>
                        <strong v-else-if="!flightObj.flightGroup[0].exchangedDate && flightObj.flightGroup[0].id.includes('_IB')">
                            {{flightObj.flightGroup[0].flight[0].flight.DepDate|formatDate}}
                        </strong>
                    </div>
                </div>
                <div>
                                                   <div  class="ex-refunded sticky-with-card-wrap" 
                                                   v-if="flightObj.flightGroup[0].flightStatus"
                                                    :class="flightObj.flightGroup[0].segmentStatus==2?
                                                   'partial-paid':flightObj.flightGroup[0].segmentStatus==10?
                                                    'paid':'unpaid'" >
                                                      <div class="dot ml-auto">

                                                       </div>
                                                       <div class="ml-auto">
                                                          
                                                          <strong :class="flightObj.flightGroup[0].segmentStatus==2?
                                                          'partial-paid':flightObj.flightGroup[0].segmentStatus==10?'paid':'unpaid'">
                                                            {{flightObj.flightGroup[0].flightStatus}}  </strong>
                                                       </div>
                                                   </div>
                </div>

                <div>
                    <div>
                        <div v-if="flightObj.flightGroup[0].pnr" class="ml-auto d-table">
                            PNR
                            <strong>
                                {{flightObj.flightGroup[0].pnr}}</strong>
                        </div>


                    </div>
                    <div @click="flightObj.showDet=!flightObj.showDet"
                         class="blue-text c-pointer d-flex align-center min-h-40px align-item-center">
                        Flight Details <img src="@imgPath/img/svg/icons/blue-icons/arrow-help.svg" height="8px"
                                            class="m-auto ml-10px" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 " v-if="!isBooking" >

            <div class="d-flex justify-content-between  mb-10px ">
                <div class="d-flex" :class="{'opacity-05':flightObj.flightStatus, 'c-pointer':!flightObj.flightStatus}">
                    <!-- <div  @click="isExchange? (flightObj.canExchange && !viewOnly?$emit('flightSelected', flightObj):null) :
                            (flightObj.canRefund  && !viewOnly && (flightObj.segmentStatus!=10 && flightObj.type!=6)?$emit('flightSelected', flightObj):null)" class="d-flex align-center justify-center mr-10px min-w-70px"> -->
                    <div @click.stop="isExchange? (flightObj.canExchange && !viewOnly?$emit('flightselected', flightObj):null) :
                            (flightObj.canRefund  && !viewOnly ?$emit('flightselected', flightObj):null)"
                         class="d-flex align-center justify-center mr-10px min-w-70px">

                        <div class="d-flex" v-if="viewOnly==false &&
                        (flightObj.hasOwnProperty('canExchange')? flightObj.canExchange : true) &&
                        (flightObj.hasOwnProperty('canRefund')? flightObj.canRefund : true) &&
                        (flightObj.hasOwnProperty('segmentStatus')?

                        (flightObj.segmentStatus==REFUND_SEGMENT_STATUS.TICKETED ||
                         flightObj.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED
                         || (flightObj.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS )
                         || flightObj.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_FAILURE): true)" >

                            <img v-if="flightObj.isSelected"
                                 class="m-auto" src="@imgPath/img/svg/icons/green-tick.svg" alt="" width="15px">
                            <img v-else-if="!flightObj.isSelected " class="m-auto"
                                 src="@imgPath/img/svg/icons/box-outline.svg" alt="" width="15px">
                            <!--                <img class="m-auto" src="@imgPath/img/svg/icons/box-outline.svg" alt="" width="15px" >-->
                            <!--                <input type="checkbox" class="m-auto">-->

                        </div>


                        <div v-else-if="viewOnly==true">
                            <img v-if="flightObj.isSelected || flightObj.segmentStatus==2 ||
                         flightObj.segmentStatus==10 || flightObj.segmentStatus==11"
                                 class="m-auto" src="@imgPath/img/svg/icons/green-tick.svg" alt="" width="15px">
                            <!-- <img v-else-if="!flightObj.isSelected " class="m-auto" src="@imgPath/img/svg/icons/box-outline.svg" alt="" width="15px"> -->
                        </div>
                        <img v-else class="m-auto opacity--2" src="@imgPath/img/svg/icons/box-outline.svg" alt=""
                             width="15px">
                    </div>
                    <div>
       <!-- <div class="flight-details-return-exchange"  :class="isExchange?{ disable: !flightObj.canExchange|| viewOnly } : { disable: !flightObj.canRefund || viewOnly}"
            @click="isExchange? (flightObj.canExchange && !viewOnly?onFlightSelection(flight):null) : (flightObj.canRefund  && !viewOnly?onFlightSelection(flight):null)"
            v-if="
                 flightObj.flightInfo && flightObj.flightInfo.length
                ">
            <div
                  class="w-100 justify-content-center d-flex flex-flow-column connection-flight-box-wrap">
                <div  class="d-flex justify-content-between w-100 m-auto connectingflight-title">
                    <div > Flight Details</div>
                </div>
                <div  class="connectingRow w-100">
                    <div  class="main-info-wrap flex-flow-column w-100">
                        <div  class="max-w-620px mt-10px w-100 m-auto">
                            <div  class="flight-code-name">
                                <div >
                                    <div  class="d-flex"><img
                                            :src="flightObj.flightInfo[0].flight.logo_url"
                                            height="30px">
                                        <div  class="ml-10px" v-if="flightObj.flightInfo[0].flight.airline_name">   <span >
                  {{ flightObj.flightInfo[0].flight.airline_name }}</span>   {{ flightObj.flightInfo[0].flight.FlightNo }}
                                        </div>
                                    </div>
                                </div>
                                <div >
                                    <div >{{$t('editFlight.class')}} {{flightObj.flightInfo[0].flight.Bookingclass}}</div>
                                </div>
                                <strong >

                                    {{flightObj.flightStatus}}   </strong>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="w-100" :class="isExchange?{ disable_column: !flightObj.canExchange|| viewOnly } :
                         { disable_column: !flightObj.canRefund || viewOnly}">
                <div class="d-flex justify-content-between  mb-10px ">
                    <div class="d-flex">
                        <div  @click="isExchange? (flightObj.canExchange && !viewOnly?$emit('flightSelected', flightObj):null) :
                            (flightObj.canRefund  && !viewOnly?$emit('flightSelected', flightObj):null)" class="d-flex align-center justify-center mr-10px min-w-70px">

                                 </div>

   </div> -->
                        <h4 :class="isExchange && flightObj.hasOwnProperty('canExchange')?( !flightObj.canExchange?'disable_column' :'c-pointer') :
                         !isExchange && flightObj.hasOwnProperty('canRefund')? (!flightObj.canRefund?'disable_column' :'c-pointer'):'c-pointer'"
                         @click="isExchange? (flightObj.canExchange && !viewOnly?$emit('flightselected', flightObj):null) :
                            (flightObj.canRefund  && !viewOnly?$emit('flightselected', flightObj):null)" class="font-bold">
                                <span>{{ flightObj.flightInfo[0].flight.DepAirport }}</span> - <span>{{ flightObj.flightInfo[flightObj.flightInfo.length-1].flight.ArrAirport }}</span>
                            </h4>
                            <span class="c-gray">
                                


        <div v-if="!isExchange" class="d-flex exchange-date-picker  " :class="isExchange && flightObj.hasOwnProperty('canExchange')?{ disable_column: !flightObj.canExchange} :
                         !isExchange && flightObj.hasOwnProperty('canRefund')? { disable_column: !flightObj.canRefund} :null">
            <label v-if="flightObj.orderItemId.includes('_OB')" class="d-flex white-space-pre align-item-center mb-0">
                Depart
            </label>
            <strong v-if=" flightObj.orderItemId.includes('_OB')" class="d-flex white-space-pre align-item-center mb-0">
                {{flightObj.exchangeDate ? flightObj.exchangeDate : flightObj.flightInfo[0].flight.DepDate|formatDate}}
            </strong>
            <label v-if="flightObj.orderItemId.includes('_IB')" class="d-flex white-space-pre align-item-center mb-0">
                Return
            </label>
            <strong v-if="flightObj.orderItemId.includes('_IB')" class="d-flex white-space-pre align-item-center mb-0">
                {{flightObj.exchangeDate ? flightObj.exchangeDate :flightObj.flightInfo[ flightObj.flightInfo.length-1].flight.ArrDate|formatDate}}
            </strong>
               <!-- <HotelDatePicker v-else-if="flightObj.canExchange && journey==2"
                                :closeDatepickerOnClickOutside="true"
                                class="center"
                                :startDate="new Date()"
                                :singleDaySelection="true"
                                :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                                :minNights="0"
                                :i18n="assigni18nObjByLang(flightObj.exchangeDate)"
                                :enableCheckout="false"
                                :showYear="true"

                                :endDate='  (  flightList[flightList.length-1].flightInfo[ 0].flight.DepDate)'

                                :displayClearButton="false"
                                :hoveringTooltip="false"
                                @check-in-changed="(val)=>{flightObj.exchangeDate=val}"
               ></HotelDatePicker>
            <HotelDatePicker v-else-if="flightObj.canExchange"
                             :closeDatepickerOnClickOutside="true"
                             class="center"
                             :startDate="new Date()"
                             :singleDaySelection="true"
                             :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                             :minNights="0"
                             :i18n="assigni18nObjByLang(flightObj.exchangeDate)"
                             :enableCheckout="false"
                             :showYear="true"


                             :displayClearButton="false"
                             :hoveringTooltip="false"
                             @check-in-changed="(val)=>{flightObj.exchangeDate=val}"
            ></HotelDatePicker> -->

        </div>
    <CRow v-if="!isBooking && isExchange">
        <CCol v-if='flightObj.exchangedDate && viewOnly'>
            <label v-if="flightObj.exchangedDate">
                {{$t('editFlight.exchangedDate')}}
            </label>

            <span>
                          <strong>


                          {{flightObj.exchangedDate|formatDate}}
                           </strong>
                        </span>
        </CCol>
         <CCol v-if='!flightObj.exchangedDate && viewOnly' class="d-flex exchange-date-picker">
            <label v-if="flightObj.orderItemId.includes('_OB')" class="d-flex white-space-pre align-item-center mb-0">
                Depart
            </label>
            <strong v-if=" flightObj.orderItemId.includes('_OB')" class="d-flex white-space-pre align-item-center mb-0">
                {{flightObj.flightInfo[0].flight.DepDate|formatDate}}
            </strong>
            <label v-if="flightObj.orderItemId.includes('_IB')" class="d-flex white-space-pre align-item-center mb-0">
                Return
            </label>
            <strong v-if="flightObj.orderItemId.includes('_IB')" class="d-flex white-space-pre align-item-center mb-0">
                {{flightObj.flightInfo[ flightObj.flightInfo.length-1].flight.ArrDate|formatDate}}
            </strong>
        </CCol>


        <CCol v-else-if="isExchange && !viewOnly" class="d-flex exchange-date-picker">

            <label class="d-flex white-space-pre align-item-center mb-0">
                Depart Date
            </label>
            <strong class='disable' v-if="!flightObj.canExchange">
                {{flightObj.exchangedDate|formatDate}}
            </strong>
            <strong v-if="flightObj.exchangedDate==null && !flightObj.canExchange">
                {{flightObj.flightInfo[0].flight.DepDate|formatDate}}
            </strong>
            
            <HotelDatePicker v-else-if="flightObj.canExchange && journey==2&&isRenderDatePicker"
                             :closeDatepickerOnClickOutside="true"
                             class="center"
                             :id="'datePicker'+flightObj.orderItemId"
                             :ref="'datePicker'+flightObj.orderItemId"
                             :startDate="new Date()"
                             :singleDaySelection="true"
                             :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                             :minNights="1"
                             :i18n="assigni18nObjByLang(flightObj.exchangeDate?flightObj.exchangeDate:flightObj.flightInfo[0].flight.DepDate)"
                             :enableCheckout="false"
                             :showYear="true"
                            
                             :endDate='  (  flightList[flightList.length-1].flightInfo[ 0].flight.DepDate)'

                             :displayClearButton="false"
                             :hoveringTooltip="false"
                             @check-in-changed="(val)=>{flightObj.exchangeDate=val,renderDatePicker()}"
            ></HotelDatePicker>
            <HotelDatePicker v-else-if="flightObj.canExchange&&isRenderDatePicker"
                             :closeDatepickerOnClickOutside="true"
                             class="center"
                             :id="'datePicker'+flightObj.orderItemId"
                             :ref="'datePicker'+flightObj.orderItemId"
                             :startDate="new Date()"
                             :singleDaySelection="true"
                             :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"
                             :minNights="1"
                             :i18n="assigni18nObjByLang(flightObj.exchangeDate?flightObj.exchangeDate:flightObj.flightInfo[0].flight.DepDate)"
                             :enableCheckout="false"
                             :showYear="true"


                             :displayClearButton="false"
                             :hoveringTooltip="false"
                             @check-in-changed="(val)=>{flightObj.exchangeDate=val,renderDatePicker()}"
            ></HotelDatePicker>
        </CCol>

                         <!--        <CCol>-->


                         <!--            <cTextInputComponent v-if='isExchange && flightObj.isSelected &&!viewOnly '-->
                         <!--                                 v-model="flightObj.remarks" :label="$t('exchange.remarks')">-->

                         <!--            </cTextInputComponent>-->


                         <!--        </CCol>-->
    </CRow>
                                <!--                 {{-->
                                <!--                  flightObj.flightInfo[0].flight.DepDate-->
                                <!--                  | formatDate-->
                                <!--                  }}-->
            </span>
                        </div>
                    </div>

                    <!-- <div>

                </div> -->
        
                <div v-if="flightObj.flightStatus" class="ex-refunded sticky-with-card-wrap"
                 :class="((flightObj.flightStatus==$t('bookingDetail.refundProcessing'))||
                 (flightObj.flightStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':
                 flightObj.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED?
                 'partial-paid':flightObj.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS?
                 'paid':'unpaid'">

                                        <div class="dot ml-auto">

                                        </div>
                                        
                    <div class="ml-auto">
                        <strong :class="((flightObj.flightStatus==$t('bookingDetail.refundProcessing'))||
                 (flightObj.flightStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':
                 flightObj.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED?'partial-paid':
                                       flightObj.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS?'paid':'unpaid'">
                            {{flightObj.flightStatus}}  </strong>
                    </div>
                </div>

                <div >
                    <div>
                        <div v-if="flightObj.pnr" class="ml-auto d-table">
                            PNR
                            <strong>
                                {{flightObj.pnr}}</strong>
                        </div>


                    </div>
                    <div @click="flightObj.showFlightDet=!flightObj.showFlightDet"
                         class="blue-text c-pointer d-flex align-center min-h-40px align-item-center">
                        Flight Details <img src="@imgPath/img/svg/icons/blue-icons/arrow-help.svg" height="8px"
                                            class="m-auto ml-10px" alt="">
                    </div>
                </div>

            </div>
        </div>

            

        <!--    <CCardBody class="mt-10px" v-if="isBooking && flightObj.showDet">-->
        <!--        <cConnectingFlightInfo-->
        <!--                :flightClass="flightObj.flightGroup[0].flight.Bookingclass"-->
        <!--                class-->
        <!--                :flightObject="flightObj.flightGroup"-->
        <!--        ></cConnectingFlightInfo>-->
        <!--    </CCardBody>-->
        <!--            :class="isExchange?{ disable_column: !flightObj.canExchange|| viewOnly } :-->
        <!--            { disable_column: !flightObj.canRefund || viewOnly}"-->
        <CCardBody class="mt-10px" v-if="!isBooking && flightObj.showFlightDet">
            <cConnectingFlightInfo
                    :flightClass="flightObj.flightInfo[0].flight.Bookingclass"
                    class
                    :flightObject="flightObj.flightInfo"
            ></cConnectingFlightInfo>


        </CCardBody>


        <!-- </div> -->

        <CCardBody class="bt-1px-gray-lit" v-if="isBooking && flightObj.showDet">
            <cConnectingFlightInfo
                    :flightClass="flightObj.flightGroup[0].flight[0].flight.Bookingclass"
                    class
                    :flightObject="flightObj.flightGroup[0].flight"
            ></cConnectingFlightInfo>
        </CCardBody>
        <hr>


        <CCardBody v-if="isBooking && paxList && paxList.orderPassengerDetails" class="pl-0 pr-0 d-flex pb-0 ">
            <div class="min-w-15px mr-10px"></div>
            <div class="w-100">
                <div class="w-100" v-if="paxList && paxList.orderPassengerDetails">
                   
                    <div class="pt-20px pb-20px  pass-card-wrap-ex-re"
                         v-for="(pax,paxIndex) in paxList.orderPassengerDetails" :key="paxIndex+'p'">
                         
                        <div class="row w-100  m-0">
                            <div class="col-md-4 d-flex mb-10px">
                                <div class="w-100">
                                    <label class="mb-0 w-100" for="asa">
                                        <h4 class="f-14px d-block text-ellipsis">{{ pax.paxTitle + " " + pax.firstName + " " + pax.lastName
                                            }}</h4>
                                        <span class="c-gray f-12px">{{pax.Gender==1?'Male':'Female'}}</span></label>
                                </div>


                            </div>
                            <div class="col-md-4 d-flex mb-10px">
                                <div class="max-w-150px ml-auto w-100">
                                    <h4 class="f-14px">{{ pax.dateOfBirth | formatDate }}</h4>
                                    <span class="c-gray f-12px">{{ $t("editPassn.dob") }}</span>
                                </div>

                            </div>
                            <div class="col-md-4 mb-10px d-flex align-items-center pr-0">
                                <div class="ex-refunded w-100 status-wrap max-w-150px ml-auto w-100 d-grid justify-content-end ">
                                    <!-- <div v-for="(paxStatus,pstatus) in flightObj.flightGroup[0].paxDetails" :key="pstatus+'icon'" class="text">
                                       <div v-if="paxIndex==paxStatus.paxId && paxStatus.paxStatus!=null">
                                            <div :class="'dot ml-auto' +'  '+paxStatus.status==10?'paid':paxStatus.status==11?'unpaid':'partial-paid'">

                                          </div>
                                       </div>
                                   </div> -->
                                   <!-- {{paxIndex}} -->
                                   <!-- {{flightObj.flightGroup[0].paxDetails[0]}} -->
                                    <!-- <div v-for="(paxStatus,pStatus) in flightObj.flightGroup[0].paxDetails" :key="pStatus+'p'" class="w-100"> -->
                                        <div class="w-100">
                                        <div class="text ml-auto" v-if=" flightObj.flightGroup[0].paxDetails[paxIndex].type!=BOOKING_ORDER_TYPE.EXCHANGE">
                                            <div  :class="flightObj.flightGroup[0].paxDetails[paxIndex].status==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS?'paid':
                                                 flightObj.flightGroup[0].paxDetails[paxIndex].status==REFUND_SEGMENT_STATUS.FULFILLED_FAILURE?'unpaid':
                                                 ((flightObj.flightGroup[0].paxDetails[paxIndex].paxStatus==$t('bookingDetail.refundProcessing'))||
                                                 (flightObj.flightGroup[0].paxDetails[paxIndex].paxStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':'partial-paid'"
                                                  v-if="flightObj.flightGroup[0].paxDetails[paxIndex].type!=BOOKING_ORDER_TYPE.EXCHANGE" 
                                                  class="d-flex align-items-center">

                                                <div class="dot" v-if="flightObj.flightGroup[0].paxDetails[paxIndex].paxStatus">

                                                </div>
                                                <div class="white-space-pre text-ellipsis d-block">
                                                    {{flightObj.flightGroup[0].paxDetails[paxIndex].paxStatus}}
                                                </div>
                                            </div>
                                        </div>
                                        </div> 
                                    <!-- </div> -->
                                </div>
                            </div>
                            <div class="col-md-4">
                                <!-- {{flightObj.flightGroup[0].paxDetails}} -->
                                <!-- <h4 class="f-14px">{{pax.ticketNumbers.toString()}}</h4>
                                            <span class="c-gray f-12px">{{ $t("editPassn.tkt_num") }}</span> -->
                                <div class=" w-100" v-for="(paxStatus,pStatus) in flightObj.flightGroup[0].paxDetails"
                                     :key="pStatus+'ptckt'">
                                    <div v-if="pax.paxId==paxStatus.paxId && paxStatus.ticketNumbers"
                                         class="col-m6-6 d-flex">
                                        <div>
                                            <h4 class="f-14px">{{paxStatus.ticketNumbers}}</h4>
                                            <span class="c-gray f-12px">{{ $t("editPassn.tkt_num") }}</span></div>
                                    </div>
                                    <div v-else-if="pax.paxId==paxStatus.paxId" class="col-m6-6 d-flex">
                                      
                                        <div>
                                            <h4 class="f-14px">- - - - - - </h4>
                                            <span class="c-gray f-12px">{{ $t("editPassn.tkt_num") }}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 d-flex ">
                                <div class="max-w-150px ml-auto w-100">
                                    <h4 class="f-14px">{{ pax.nationality_name }}</h4>
                                    <span class="c-gray f-12px">{{ $t("editPassn.nat") }}</span>
                                </div>

                            </div>
                            <div class="col-md-4 dek-pr-0 ">
                                <div class="pr-0">
                                    <div class="ml-auto max-w-150px w-100">
                                        <div class="d-flex">
                                            <div  class="d-flex align-items-baseline flex-flow-column w-100"><h4
                                                    class="f-14px text-right text-ellipsis w-100"
                                                  >{{ pax.idNumber?pax.idNumber:'------------' }}</h4>
                                                <div class="c-gray f-12px text-right d-flex w-100"><span class="ml-auto">{{ $t("editPassn.rep_doc_id") }}</span></div>
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </CCardBody>

        <CCardBody v-if="!isBooking" class="pl-0 pr-0 d-flex pb-0" :class="{'opacity-05':flightObj.flightStatus}">
            <div class="min-w-15px mr-10px"></div>
            <div class="w-100">
                <div class="w-100" v-if="paxList && paxList.length">

                    <!-- isExchange? (pax.canExchange && !viewOnly? $emit('paxSelected', pax, paxList, flightObj.orderItemId):null) : -->
                    <!-- <div class="pt-10px pb-10px c-pointer" @click="(pax.canRefund  && !viewOnly && (pax.hasOwnProperty('status') && pax.hasOwnProperty('type')?
                                (pax.status!=10 || pax.type!=6):false) ? $emit('paxSelected', pax, paxList, flightObj.orderItemId):null)" -->
                    <!--<div :class="{c-pointer:index}">-->

                    <!--</div>-->

                    <div class="pt-10px pb-10px"
                         @click.stop="(pax.canRefund  && !viewOnly ? $emit('paxselected', pax, paxList, flightObj.orderItemId):null)"
                         v-for="(pax, index) in paxList"
                         :key="'i' + index"
                         :class="isExchange ? viewOnly
                          : (!isExchange &&  pax.hasOwnProperty('canRefund')) ?(!pax.canRefund?'disable_column':'c-pointer') :'c-pointer'">

                        <div class="row w-100  ">
                            <div class="col-md-2">
                                <div v-if="isExchange==false && !viewOnly && ( pax.hasOwnProperty('status') ? 
                                (pax.status==REFUND_SEGMENT_STATUS.TICKETED ||
                                 pax.status==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED || pax.status==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS
                                  || pax.status==REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) : true)
                                 && (pax.hasOwnProperty('canRefund')? pax.canRefund :true) "
                                     class="d-flex align-center justify-center mr-10px min-w-70px">

                                    <img class="m-auto" src="@imgPath/img/svg/icons/green-tick.svg" alt=""
                                         width="15px"
                                         v-if="(pax.isSelected )">
                                    <img class="m-auto" src="@imgPath/img/svg/icons/box-outline.svg" alt=""
                                         width="15px"
                                         v-else>
                                </div>
                                <div v-else-if="!isExchange && viewOnly"
                                     class="d-flex align-center justify-center mr-10px min-w-70px">

                                    <img v-if=" pax.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED ||
                                              pax.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS ||
                                             pax.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_FAILURE"
                                         class="m-auto" src="@imgPath/img/svg/icons/green-tick.svg" alt="" width="15px">
                                    <!--                         <img v-else class="m-auto" src="@imgPath/img/svg/icons/box-outline.svg" alt="" width="15px">-->
                                </div>
                                <!--                                v-if="isExchange"-->
                                <div v-else-if="!isExchange && pax.canRefund" class="d-flex align-center justify-center mr-10px min-w-70px">
                                    <img class="m-auto " src="@imgPath/img/svg/icons/box-outline.svg" alt=""
                                         width="15px">
                                </div>
                            </div>
                            <div class="col-md-4 d-flex">

                                <!--                                <div  class="min-w-70px mr-10px">-->
                                <!--                                   -->
                                <!--                                </div>-->
                                <!--                                <div v-if="isExchange" class="d-flex align-center justify-center mr-10px min-w-70px">-->
                                <!--                                    -->
                                <!--                                </div>-->
                                <label class="mb-0 w-100" for="asa">
                                    <h4 class="f-14px text-left text-ellipsis w-100 d-block ">{{ pax.title + " " + pax.firstName + " " + pax.lastName }}</h4>
                                    <span class="c-gray f-12px">{{pax.gender==1?'Male':'Female'}}</span></label>
                            </div>
                            <div class="col-md-3 d-flex ">
                                <div class="ml-auto max-w-150px w-100">
                                    <h4 class="f-14px text-left text-ellipsis w-100 d-block ">{{ pax.dob | formatDate }}</h4>
                                    <span class="c-gray f-12px">{{ $t("editPassn.dob") }}</span>
                                </div>

                            </div>
                            <div class="col-md-3 dek-pr-0 p-unset">
                                <div v-if="!isExchange && pax.paxStatus"  
                                :class="(( pax.paxStatus==$t('bookingDetail.refundProcessing'))||
                                                 ( pax.paxStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':
                                                 pax.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED?'partial-paid'
                                        :pax.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS?'paid':'unpaid'">
<!--                                    <div class="dot">-->

<!--                                    </div>-->
                                    <div class="w-100">
                                        <div class="status-wrap ">
                                            <div class="d-flex align-items-center"
                                                 :class="(( pax.paxStatus==$t('bookingDetail.refundProcessing'))||
                                                 ( pax.paxStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':pax.segmentStatus==2?'partial-paid':pax.segmentStatus==10?'paid':'unpaid'">

                                        <div class="d-flex align-items-center" :class="(( pax.paxStatus==$t('bookingDetail.refundProcessing'))||
                                                 ( pax.paxStatus==$t('bookingDetail.exchangeProcessing')))?'processing_c':
                                        pax.segmentStatus==REFUND_SEGMENT_STATUS.CHANGE_REQUESTED?'partial-paid'
                                        :pax.segmentStatus==REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS?'paid':'unpaid'">
                                            <div class="dot">

                                                </div>
                                                
                                                <strong class="line-h15  d-block">

                                                    {{pax.paxStatus}} </strong>
                                            </div>


                                    </div>
                                </div>
                            </div>


                        </div>


                    </div>

                       </div>
                        <br />
<!--                        v-if="!isExchange && pax.paxStatus"-->
                        <div class="row w-100" >
                            <div class="col-md-2">
<!--                                v-if="isExchange==false && !viewOnly && ( pax.hasOwnProperty('status') ? (pax.status==1 ||-->
<!--                                pax.status==10 || pax.status==11 || pax.status==2) : true)-->
<!--                                && (pax.hasOwnProperty('canRefund')? pax.canRefund :true) "-->
<!--                                <div v-else class="d-flex align-center justify-center mr-10px min-w-70px">-->
                                    <!--                                        <img class="m-auto " src="@imgPath/img/svg/icons/box-outline.svg" alt="" width="15px">-->
<!--                                </div>-->
                            </div>
                                <div class="col-md-4 d-flex">



                                    <div><h4 class="f-14px">{{ pax.ticketNumber }}</h4>
                                        <span class="c-gray f-12px">{{ $t("editPassn.tkt_num") }}</span></div>
                                </div>
                                <div class="col-md-3 d-flex ">
                                    <div class="max-w-150px ml-auto w-100">
                                        <h4 class="f-14px">{{ pax.nationality }}</h4>
                                        <span class="c-gray f-12px">{{ $t("editPassn.nat") }}</span>
                                    </div>

                                </div>
                                <div class="col-md-3 dek-pr-0">
                                    <div><h4 class="f-14px text-right">{{ pax.DocumentId?pax.DocumentId:'------------' }}</h4>
                                        <span class="c-gray f-12px text-left"><span class="ml-auto">{{ $t("editPassn.rep_doc_id") }}</span></span>
                                    </div>
                                </div>
                            </div>

                        <!-- <br v-if="isExchange && pax.paxStatus"/> -->
                        <!-- <div class="row w-100 " v-if="isExchange && pax.paxStatus">
                            <div class="col-md-2">
                                <div class="d-flex align-center justify-center mr-10px min-w-70px">

                                </div>
                            </div>
                            <div class="col-md-4 d-flex ">

                                <div class=" max-w-150px w-100">
                                    <h4 class="f-14px">{{pax.ticketNumber}}</h4>
                                    <span class="c-gray f-12px">Ticket Number</span>
                                </div>

                            </div>
                            <div class="col-md-3 d-flex ">
                                <div class="ml-auto max-w-150px w-100">
                                    <h4 class="f-14px">{{ pax.nationality}}</h4>
                                    <span class="c-gray f-12px">Nationality</span>
                                </div>

                            </div>
                            <div class="col-md-3 d-flex ">
                                <div class="ml-auto max-w-150px w-100">
                                    <h4 class="f-14px">{{ pax.DocumentId}}</h4>
                                    <span class="c-gray f-12px">Doc Number</span>
                                </div>

                            </div>
                        </div> -->

            </div>
<!--user table start-->

<!--                                    <div class="mt-10px">-->
<!--                                        <CRow class="sp">-->
<!--                                            <CCol></CCol>-->
<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.pName") }}</strong>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.gender") }}</strong>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.rep_doc_id") }}</strong>-->
<!--                                            </CCol>-->

<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.dob") }}</strong>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.nat") }}</strong>-->
<!--                                            </CCol>-->

<!--                                            <CCol>-->
<!--                                                <strong>{{ $t("editPassn.tkt_num") }}</strong>-->
<!--                                            </CCol>-->
<!--                                        </CRow>-->
<!--                                    </div>-->

<!--                                    <div v-if="paxList && paxList.length">-->
<!--                                        <CRow-->
<!--                                                @click="isExchange? (pax.canExchange && !viewOnly? $emit('paxSelected', pax, paxList):null) :-->
<!--                                    (pax.canRefund  && !viewOnly? $emit('paxSelected', pax, paxList):null)"-->
<!--                                                class="sp"-->
<!--                                                :class="isExchange?{ disable: !pax.canExchange|| viewOnly } : { disable: !pax.canRefund || viewOnly}"-->
<!--                                                v-for="(pax, index) in paxList"-->
<!--                                                :key="'i' + index"-->
<!--                                        >-->
<!--                                            <CCol>-->
<!--                                                <CIcon v-if="pax.isSelected" name="cil-star"></CIcon>-->

<!--                                                <CIcon v-else name="cil-ban"></CIcon>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <span>{{ pax.title + " " + pax.firstName + " " + pax.lastName }}</span>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <span>{{pax.gender==1?'Male':'Female'}}</span>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <span>{{ pax.DocumentId }}</span>-->
<!--                                            </CCol>-->

<!--                                            <CCol>-->
<!--                                                <span>{{ pax.dob | formatDate }}</span>-->
<!--                                            </CCol>-->
<!--                                            <CCol>-->
<!--                                                <span>{{ pax.nationality }}</span>-->
<!--                                            </CCol>-->

<!--                                            <CCol>-->
<!--                                                <span>{{ pax.ticketNumber }}</span>-->
<!--                                            </CCol>-->
<!--                                        </CRow>-->
<!--                                    </div>-->
<!--            user table end-->
                </div>
            </div>
        </CCardBody>
        <!-- <CCardHeader>
          <strong>{{$t('editPassn.paxDet')}}</strong>
      </CCardHeader> -->

        <!--                <CCardHeader>-->
        <!--                    <CRow v-if="isBooking">-->
        <!--                        <CCol>-->
        <!--                            <strong>{{flightObj.flightGroup[0].flight.DepAirport}}-</strong>-->
        <!--                            <strong>{{flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrAirport}}</strong>-->

        <!--                            <div>-->
        <!--                                {{flightObj.id.includes("_IB")?'DEPART':'RETURN'}} - -->
        <!--                                {{flightObj.flightGroup[0].flight.DepDate|formatDate}}-->
        <!--                            </div>-->
        <!--                        </CCol>-->

        <!--                        <CCol>-->
        <!--                            <div v-if="flightObj.pnr">-->
        <!--                                PNR-->
        <!--                                {{flightObj.pnr}}-->
        <!--                            </div>-->
        <!--                            <div @click="flightObj.showDet=!flightObj.showDet">flight Details</div>-->
        <!--                        </CCol>-->
        <!--                    </CRow>-->
        <!--                    <CRow v-else-if="!isBooking" :style="{ color: flightObj.isSelected ? 'red' : 'blue' }">-->
        <!--                        <strong>-->
        <!--                            &lt;!&ndash; {{-->
        <!--                            ( journey==3)? $t("editFlight.leg")+(index+1): ( journeyType==2 && index==1)? $t("editFlight.retFlight") : $t("editFlight.depFlight")-->
        <!--                            }} &ndash;&gt;-->
        <!--                        </strong>-->
        <!--                    </CRow>-->
        <!--                    <br/>-->

        <!--                    <CRow-->
        <!--                            :class="isExchange?{ disable: !flightObj.canExchange|| viewOnly } : { disable: !flightObj.canRefund || viewOnly}"-->
        <!--                            @click="isExchange? (flightObj.canExchange && !viewOnly?$emit('flightSelected', flightObj):null) :-->
        <!--                      (flightObj.canRefund  && !viewOnly?$emit('flightSelected', flightObj):null)"-->

        <!--                            v-if="flightObj.flightInfo && flightObj.flightInfo.length && !isBooking"-->
        <!--                    >-->
        <!--                        <CCol>-->
        <!--                            <CIcon v-if="flightObj.isSelected" name="cil-star"></CIcon>-->
        <!--                            <CIcon v-else name="cil-ban"></CIcon>-->
        <!--                        </CCol>-->

        <!--                        <CCol>-->
        <!--                            <img :src="flightObj.flightInfo[0].flight.logo_url" width="40px"/>-->
        <!--                        </CCol>-->
        <!--                        <CCol v-if="flightObj.flightInfo[0].flight.airline_name">-->
        <!--                            <strong style="white-space: nowrap">{{ flightObj.flightInfo[0].flight.airline_name }}</strong>-->
        <!--                            <br/>-->
        <!--                            <span>{{ flightObj.flightInfo[0].flight.FlightNo }}</span>-->
        <!--                        </CCol>-->
        <!--                        <CCol>{{$t('editFlight.class')}} {{flightObj.flightInfo[0].flight.Bookingclass}}</CCol>-->
        <!--                        <CCol>-->
        <!--                        <span>-->
        <!--                          {{-->
        <!--                          flightObj.flightInfo[0].flight.DepDate-->
        <!--                          | formatDate-->
        <!--                          }}-->
        <!--                        </span>-->
        <!--                            <strong>-->
        <!--                                {{-->
        <!--                                flightObj.flightInfo[0].flight.DepDate-->
        <!--                                |formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
        <!--                                }}-->
        <!--                            </strong>-->
        <!--                            <br/>-->
        <!--                            <span>{{ flightObj.flightInfo[0].flight.DepAirport }}</span>-->

        <!--                            <span>{{ flightObj.flightInfo[0].flight.depCity }}</span>-->
        <!--                        </CCol>-->

        <!--                        <CCol>{{flightObj.travelDuration|convertToHrMin("minutes","H [h] mm [m]") }}</CCol>-->

        <!--                        <div class="f_icon">-->
        <!--                            <img src="~@imgPath/img/svg/icons/flight-black.svg" alt/>-->
        <!--                            {{ flightObj.flightInfo[0].connectingNumber==null?-->
        <!--                            $t('editFlight.nonStop'):(flightObj.flightInfo.length-1)+ $t('editFlight.stops') }}-->
        <!--                            <br/>-->

        <!--                            <br/>-->
        <!--                        </div>-->

        <!--                        <CCol></CCol>-->
        <!--                        <CCol>-->
        <!--                        <span>-->
        <!--                          {{-->
        <!--                          flightObj.flightInfo[ flightObj.flightInfo.length-1].flight.ArrDate-->
        <!--                          | formatDate-->
        <!--                          }}-->
        <!--                        </span>-->
        <!--                            <strong>-->
        <!--                                {{-->
        <!--                                flightObj.flightInfo[ flightObj.flightInfo.length-1].flight.ArrDate-->
        <!--                                | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
        <!--                                }}-->
        <!--                            </strong>-->
        <!--                            <br/>-->
        <!--                            <span>{{ flightObj.flightInfo[flightObj.flightInfo.length-1].flight.ArrAirport }}</span>-->
        <!--                            <span>{{ flightObj.flightInfo[flightObj.flightInfo.length-1].flight.arrCity}}</span>-->
        <!--                        </CCol>-->
        <!--                    </CRow>-->
        <!--                    <br/>-->
        <!--                    <CRow v-if="!isBooking && isExchange">-->

        <!--                        <CCol v-if='viewOnly'>-->
        <!--                            <label v-if="flightObj.exchangedDate">-->
        <!--                                {{$t('editFlight.exchangedDate')}}-->
        <!--                            </label>-->

        <!--                            <span>-->
        <!--                          <strong>-->


        <!--                          {{flightObj.exchangedDate|formatDate}}-->
        <!--                           </strong>-->
        <!--                        </span>-->

        <!--                        </CCol>-->
        <!--                        <CCol v-else-if="isExchange && !viewOnly">-->

        <!--                            <label>-->
        <!--                                {{$t('editFlight.exchangeDate')}}-->
        <!--                            </label>-->
        <!--                            <strong class="disable" v-if="!flightObj.canExchange">-->
        <!--                                {{flightObj.exchangeDate|formatDate}}-->
        <!--                            </strong>-->
        <!--                            <HotelDatePicker v-else-if="flightObj.canExchange && journey==2"-->
        <!--                                             :closeDatepickerOnClickOutside="true"-->

        <!--                                             :startDate="new Date()"-->
        <!--                                             :singleDaySelection="true"-->
        <!--                                             :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"-->
        <!--                                             :minNights="0"-->
        <!--                                             :i18n="assigni18nObjByLang(flightObj.exchangeDate)"-->
        <!--                                             :enableCheckout="false"-->
        <!--                                             :showYear="true"-->

        <!--                                             :endDate='  (  flightList[flightList.length-1].flightInfo[ 0].flight.DepDate)'-->

        <!--                                             :displayClearButton="false"-->
        <!--                                             :hoveringTooltip="false"-->
        <!--                                             @check-in-changed="(val)=>{flightObj.exchangeDate=val}"-->
        <!--                            ></HotelDatePicker>-->
        <!--                            <HotelDatePicker v-else-if="flightObj.canExchange"-->
        <!--                                             :closeDatepickerOnClickOutside="true"-->

        <!--                                             :startDate="new Date()"-->
        <!--                                             :singleDaySelection="true"-->
        <!--                                             :format="DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT"-->
        <!--                                             :minNights="0"-->
        <!--                                             :i18n="assigni18nObjByLang(flightObj.exchangeDate)"-->
        <!--                                             :enableCheckout="false"-->
        <!--                                             :showYear="true"-->


        <!--                                             :displayClearButton="false"-->
        <!--                                             :hoveringTooltip="false"-->
        <!--                                             @check-in-changed="(val)=>{flightObj.exchangeDate=val}"-->
        <!--                            ></HotelDatePicker>-->
        <!--                        </CCol>-->

        <!--                        <CCol>-->


        <!--                            <cTextInputComponent v-if='isExchange && flightObj.isSelected &&!viewOnly '-->
        <!--                                                 v-model="flightObj.remarks" :label="$t('exchange.remarks')">-->

        <!--                            </cTextInputComponent>-->


        <!--                        </CCol>-->
        <!--                    </CRow>-->

        <!--                    <br/>-->
        <!--                </CCardHeader>-->


        <!--        <CCardBody v-if="!isBooking && flightObj.flightInfo && flightObj.flightInfo.length>1">-->

        <!--            <cConnectingFlightInfo-->
        <!--                    :flightClass="flightObj.flightInfo[0].flight.Bookingclass"-->
        <!--                    class-->
        <!--                    :flightObject="flightObj.flightInfo"-->
        <!--            ></cConnectingFlightInfo>-->
        <!--             <CRow >-->
        <!--                      <div v-for="(connFlight,ind) in flightObj.flightInfo" :key="ind">-->
        <!--                        <CRow style="margin-left: 300px;">-->
        <!--                          <CCol>-->
        <!--                            <img :src="connFlight.flight.logo_url" width="40px" />-->
        <!--                          </CCol>-->
        <!--                          <CCol v-if="connFlight.flight.airline_name">-->
        <!--                            <strong style="white-space: nowrap">{{ connFlight.flight.airline_name }}</strong>-->
        <!--                            <br />-->
        <!--                            <span>{{ connFlight.flight.FlightNo }}</span>-->
        <!--                          </CCol>-->
        <!--                          <CCol-->
        <!--                            v-if="connFlight.Bookingclass"-->
        <!--                          >{{$t('editFlight.class')}} {{connFlight.Bookingclass}}</CCol>-->
        <!--                          <CCol>-->
        <!--                            <span>-->
        <!--                              {{-->
        <!--                              connFlight.flight.DepDate-->
        <!--                              | formatDate-->
        <!--                              }}-->
        <!--                            </span>-->
        <!--                            <strong>-->
        <!--                              {{-->
        <!--                              connFlight.flight.DepDate-->
        <!--                              | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
        <!--                              }}-->
        <!--                            </strong>-->
        <!--                            <br />-->
        <!--                            <span>{{ connFlight.flight.DepAirport }}</span>-->
        <!--                            <span>{{ connFlight.flight.depCity }}</span>-->
        <!--                          </CCol>-->

        <!--                          <CCol-->
        <!--                            style="    white-space: nowrap"-->
        <!--                          >{{connFlight.flight.DurationInMin|convertToHrMin("minutes","H [h] mm [m]") }}</CCol>-->

        <!--                          <CCol></CCol>-->
        <!--                          <CCol>-->
        <!--                            <span>-->
        <!--                              {{-->
        <!--                              flightObj.flightInfo[ flightObj.flightInfo.length-1].flight.ArrDate-->
        <!--                              | formatDate-->
        <!--                              }}-->
        <!--                            </span>-->
        <!--                            <strong>-->
        <!--                              {{-->
        <!--                              connFlight.flight.ArrDate-->
        <!--                              | formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)-->
        <!--                              }}-->
        <!--                            </strong>-->
        <!--                            <br />-->
        <!--                            <span>{{ connFlight.flight.ArrAirport }}</span>-->
        <!--                            <span>{{ connFlight.flight.arrCity}}</span>-->
        <!--                          </CCol>-->
        <!--                        </CRow>-->
        <!--                      </div>-->
        <!--            </CRow>-->
        <!--        </CCardBody>-->


    </div>
</template>
<script>
    import {
        
        REFUND_SEGMENT_STATUS,
        BOOKING_ORDER_TYPE,
        DATE_TIME_FORMAT,
        ORDER,
       
        DEFAULT_DROPDOWN_STATUS,
        ALERT_MODAL_STATUS,
        COMPONENT_NAME
    } from "../../../../util/constants";
    import {formatDate} from "./../../../../util/date/dateFunctions";
    import {mapGetters, mapActions} from "vuex";
    import BaseConfiguration from "../../../../config/base";
    import HotelDatePicker from "vue-range-datechooser";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../../config/API_DATA";
    import cTextInputComponent from './../../../form/cTextInputComponent'
    import Logger from "../../../../services/logger";
    import cConnectingFlightInfo from "../../../result/cConnectingFlightInfo";
     import Vue from "vue";

    export default {
        name: 'cFlightLegWithPax',

        components: {
            HotelDatePicker,
            cTextInputComponent,
            cConnectingFlightInfo
        },

        data: () => {
            return {
                lsFlights: [],
                REFUND_SEGMENT_STATUS:REFUND_SEGMENT_STATUS,
                BOOKING_ORDER_TYPE:BOOKING_ORDER_TYPE,
                isRenderDatePicker:true,
            };
        },

        computed: {
            DATE_TIME_FORMAT() {
                return DATE_TIME_FORMAT;
            }
        },
        props: {
            flightObj: {
                type: Object | Array,
                default: null
            },
            flightList: {
                type: Object | Array,
                default: null
            },
            paxList: {
                type: Object | Array,
                default: null
            },
            isBooking: {
                type: Boolean,
                default: false
            },
            viewOnly: {
                type: Boolean,
                default: false
            },
            isExchange: {
                type: Boolean,
                default: false
            },
            journey: {
                type: String | Number,
                default: null
            },
        },

        mounted() {

            this.$root.$on("openExcDatePicker",(isOpen,order) => {

                if(Object.keys(this.$refs).length != 0 &&this.$refs['datePicker'+order]!=undefined){
                    this.$refs['datePicker'+order].isOpen=isOpen
                }
            });

            //  this.$root.$on("gotApiCallCount",(pApiCallCount) => {
            //     alert('open')
            // });

            
        },

        methods: {
            renderDatePicker() {
                try {
                  if(BaseConfiguration.isDebug) console.log("renderDatePicker");
                  this.isRenderDatePicker=false;
                let that = this;
                         Vue.nextTick(function () {
                            that.isRenderDatePicker = true;
                        });
            
                } catch (err) {
                        let body = Logger.buildRequest(
                         COMPONENT_NAME.C_FLIGHT_LEG_WITH_PAX,
                          "error in renderDatePicker",
                          err.toString(),
                          "renderDatePicker",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 
            assigni18nObjByLang(pCurrDueDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

                    retValue = {
                        night: this.$t("flightDatePicker.night"),
                        nights: this.$t("flightDatePicker.nights"),
                        "day-names": [
                            this.$t("flightDatePicker.sun"),
                            this.$t("flightDatePicker.mon"),
                            this.$t("flightDatePicker.tue"),
                            this.$t("flightDatePicker.wed"),
                            this.$t("flightDatePicker.thur"),
                            this.$t("flightDatePicker.fri"),
                            this.$t("flightDatePicker.sat")
                        ],
                        "check-in": pCurrDueDate
                            ? formatDate(pCurrDueDate, DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT)
                            : this.$t("flightDatePicker.checkIn"),
                        "check-out": this.$t("flightDatePicker.checkOut"),
                        "month-names": [
                            this.$t("flightDatePicker.jan"),
                            this.$t("flightDatePicker.feb"),
                            this.$t("flightDatePicker.mar"),
                            this.$t("flightDatePicker.apr"),
                            this.$t("flightDatePicker.may"),
                            this.$t("flightDatePicker.jun"),
                            this.$t("flightDatePicker.july"),
                            this.$t("flightDatePicker.aug"),
                            this.$t("flightDatePicker.sep"),
                            this.$t("flightDatePicker.oct"),
                            this.$t("flightDatePicker.nov"),
                            this.$t("flightDatePicker.dec")
                        ]
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_EDIT_FLIGHT,
                        "error in assigni18nObjByLang",
                        err.toString(),
                        "assigni18nObjByLang",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            }
        }

    };
</script>
<style>
.paid{
    color: green;
}
.unpaid{
    color: red;
}
.partial-paid{
    color:orange;
}
.processing_c{
    color: #20a8d8;
}
</style>